<script setup>
import VOtpInput from 'vue3-otp-input';

const props = defineProps({
  placeholder: {
    type: String,
    default: undefined,
  },
  modelValue: {
    type: String,
    default: undefined,
  },

  type: {
    type: String,
    default: 'number',
    validator: (value) =>
      ['password', 'number', 'tel', 'letter-numeric'].includes(value),
  },
  length: {
    type: Number,
    default: 4,
  },

  validation: {
    type: [String, Object],
    default: undefined,
  },
});
const emit = defineEmits(['update:modelValue', 'complete']);

const placeholderArray = computed(() =>
  Array.from({ length: props.length }, () => props.placeholder),
);

const localValue = useVModel(props, 'modelValue', emit);

function handleOnComplete() {
  emit('complete');
}
</script>

<template>
  <div class="form-field-code">
    <VeeField
      v-slot="{ errors }"
      v-model="localValue"
      name="code"
      :label="placeholder"
      :rules="validation"
      :validate-on-model-update="false"
    >
      <VOtpInput
        v-model:value="localValue"
        should-focus-order
        class="form-field-code__container"
        input-classes="form-field-code__input"
        separator=""
        inputmode="numeric"
        :input-type="type"
        :num-inputs="length"
        :placeholder="placeholderArray"
        @on-complete="handleOnComplete"
      />

      <div v-if="errors.length" class="form-field-code__error">
        <span class="form-field-code__font">
          {{ errors[0] }}
        </span>
      </div>
    </VeeField>
  </div>
</template>

<style lang="scss" scoped>
.form-field-code {
  $parent: &;

  &__font {
    display: block;
    font-size: em(12);
    font-weight: 400;
    line-height: math.div(13, 12);
    color: $color-error;
  }

  &__container {
    gap: em(8);
    width: auto;
  }

  &__error {
    margin-top: em(4);
  }

  :deep(.form-field-code__input) {
    width: em(57, 90);
    font-size: em(90);
    color: $color-main-5;
    text-align: center;
    appearance: textfield;
    border-bottom: 1px solid $color-black;

    &::placeholder {
      color: $color-gray-4;
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin: 0;
      appearance: none;
    }
  }
}
</style>
